if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				if (this.querySelector(".loading-overlay__spinner")) {
					this.querySelector(".loading-overlay__spinner").classList.remove(
						"hidden"
					);
				}

				let cartWasUpdated = false;
				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				return fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {

							// dispatch cart:error
							document.dispatchEvent(
								new CustomEvent("cart:error", {
									detail: {
										sectionId: this.dataset.source,
										productVariantId: formData.get("id"),
										errors: response.description,
										message: response.message,
									},
								})
            	);

							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						cartWasUpdated = true;

						// dispatch variant:add
						document.dispatchEvent(
							new CustomEvent("variant:add", {
								detail: {
									variant: {
										id: formData.get("id"),
									},
									quantity: Number(formData.get("quantity") || 1),
									formElement: this.form,
									sectionId: this.dataset.source,
								},
							})
						);

						fetch(`${routes.cart_url}.js`)
							.then((response) => {
								return response.text();
							})
							.then((state) => {
								const parsedState = JSON.parse(state);

								// dispatch cart:change for the entire basket
								document.dispatchEvent(
									new CustomEvent('cart:change', {
										detail: {
											cart: parsedState,
											sectionId: this.dataset.source
										}
									})
								);
								// dispatch cart:change for the entire basket
							})
							.catch((error) => {
								console.error('Error fetching cart state:', error);
							});

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										try {
											this.cart.renderContents(response);
										} catch (error) {
											window.location = window.routes.cart_url;
										}
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						if (cartWasUpdated) {
							window.location = window.routes.cart_url;
							return;
						}
						this.error = false;
						this.handleErrorMessage(window.cartStrings.error, true);
						const detail = {
							sectionId: this.dataset.source,
							productVariantId: formData.get("id"),
							errors: window.cartStrings.error,
							message: window.cartStrings.error,
						};
						document.dispatchEvent(new CustomEvent("cart:error", { detail }));
						publish(PUB_SUB_EVENTS.cartError, { ...detail, source: "product-form" });
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						if (this.querySelector(".loading-overlay__spinner")) {
							this.querySelector(".loading-overlay__spinner").classList.add(
								"hidden"
							);
						}
					});
			}

			handleErrorMessage(errorMessage = false, forceShow = false) {
				if (this.hideErrors && !forceShow && errorMessage) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper && forceShow) {
					this.errorMessageWrapper = document.createElement("div");
					this.errorMessageWrapper.className = "product-form__error-message-wrapper";
					const message = document.createElement("span");
					message.className = "product-form__error-message";
					this.errorMessageWrapper.appendChild(message);
					this.appendChild(this.errorMessageWrapper);
				}
				if (!this.errorMessageWrapper) return;
				this.errorMessageWrapper.setAttribute("role", "alert");
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}

